<template>
	<Row class="flex-1 flex-align-center flex-justify-space-between">
		<Row class="flex-align-center width-100 mr-5">
			<Row class="mr-4">
				<AppTooltip :disabled="showName || !user" :text="userFullName">
					<SettingsManageUsersInfoAvatar v-if="user" :user="user" :size="25" />
					<div class="n-a" v-else>N/A</div>
				</AppTooltip>
			</Row>
			<v-menu v-if="showSlider" open-on-hover min-width="124" max-width="124" rounded top nudge-top="27" nudge-right="50">
				<template v-slot:activator="{ on, attrs }">
					<div v-on="on" v-bind="attrs" class="slider" :style="sliderStyle" />
				</template>
				<Col class="slider-tooltip flex-justify-center">
					<h5 class="bold">{{ userFullName }}</h5>
					<h5 class="light">{{ numOfRuns }} Runs</h5>
				</Col>
			</v-menu>
			<h3 class="reg ml-3" v-if="showName">{{ userFullName }}</h3>
		</Row>
		<h3 v-if="numOfRuns" class="reg">{{ numOfRuns }}</h3>
	</Row>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service.js';
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar.vue';

export default {
	name: 'AnalyticsTopUserItem',
	components: { SettingsManageUsersInfoAvatar },
	props: {
		index: { type: Number },
		numOfRuns: { type: Number },
		userId: { type: [String, Number] },
		maxNumOfRunsOnDisplay: { type: Number },
		numOfElementOnDisplay: { type: Number },
		showName: { type: Boolean, default: false },
		showSlider: { type: Boolean, default: true },
	},
	computed: {
		...mapGettersShorthand({ teamMemberByUserId }),
		user() {
			return this.teamMemberByUserId(this.userId);
		},
		percentageOfRunsOutOfMax() {
			const maxPercentage = 85;
			const perc = Math.round((this.numOfRuns / this.maxNumOfRunsOnDisplay) * maxPercentage);
			return Math.max(perc, 5);
			//return Math.round((this.numOfRuns / this.maxNumOfRunsOnDisplay) * maxPercentage);
		},
		userFullName() {
			return AppAvatarService.getUserFullName(this.user);
		},
		sliderStyle() {
			return {
				width: this.animate ? `${this.percentageOfRunsOutOfMax}%` : '0px',
				opacity: (0.8 / this.numOfElementOnDisplay) * (this.numOfElementOnDisplay - this.index),
			};
		},
	},
	mounted() {
		setTimeout(() => {
			this.animate = true;
		}, this.animationDelayMS);
	},
	data() {
		return {
			animate: false,
			animationDelayMS: 10,
		};
	},
};
</script>
<style scoped lang="scss">
.slider {
	height: 25px;
	background-color: #4ec0bf;
	border-radius: 3px 3px 0px 0px;
	transition: width 0.5s ease-in-out;
	&:hover {
		transition: 0.2s;
		opacity: 1 !important;
	}
}
.slider-tooltip {
	padding: 7px 5px;
	background: #0a0a0abe;
	border: 1px solid #666666;
	h5 {
		color: #f9fafc;
	}
}
.n-a {
	max-width: 25px;
}
</style>
